import React, { useEffect, useState } from 'react';
import Navbar from "../main_website/Navbar";
import Whatsapp from './Whatsapp';
import Footer from "../main_website/Footer";
import '../css/ImageGallery.css';

const ImageGallery = () => {
  const [folders, setFolders] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [images, setImages] = useState([]);

  // ✅ Fetch folders from full API URL
  useEffect(() => {
    fetch('https://adinathbuilder.com/admin/api/folders')
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setFolders(data.data);
        }
      })
      .catch((err) => console.error('Error fetching folders:', err));
  }, []);

  // ✅ Fetch images using full API URL
  const openFolder = (folderId) => {
    setSelectedFolderId(folderId);
    setSelectedImageIndex(null);

    fetch(`https://adinathbuilder.com/admin/api/images?id=${folderId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          const updatedImages = data.data.map((img) => ({
            ...img,
            image_url: `https://adinathbuilder.com/admin/public/${img.image_path}`,
          }));
          setImages(updatedImages);
        } else {
          setImages([]);
        }
      })
      .catch((err) => console.error('Error fetching images:', err));
  };

  const openImageViewer = (index) => setSelectedImageIndex(index);
  const closeImageViewer = () => setSelectedImageIndex(null);
  const showNextImage = () => setSelectedImageIndex((selectedImageIndex + 1) % images.length);
  const showPreviousImage = () => setSelectedImageIndex((selectedImageIndex - 1 + images.length) % images.length);

  return (
    <div>
      <div className="gallery-container">
        <Navbar />

        <div className="folders">
          {folders.map((folder) => (
            <div key={folder.id} className="folder" onClick={() => openFolder(folder.id)}>
              📂 <p className="folder-name">{folder.folder_name}</p>
            </div>
          ))}
        </div>

        {selectedFolderId && (
          <div className="folder-content">
            <h2>{folders.find(f => f.id === selectedFolderId)?.folder_name}</h2>
            {images.length > 0 ? (
              <div className="gallery-grid">
                {images.map((img, index) => (
                  <div key={img.id} className="gallery-item" onClick={() => openImageViewer(index)}>
                    <img
                      src={img.image_url}
                      alt={img.image_alt || `Image ${index + 1}`}
                      className="gallery-thumbnail"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/fallback-image.jpg";
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ textAlign: 'center', marginTop: '2rem' }}>No images found in this folder.</p>
            )}
          </div>
        )}

        {selectedImageIndex !== null && (
          <div className="image-viewer">
            <span className="close" onClick={closeImageViewer}>&times;</span>
            <button className="prev-btn" onClick={showPreviousImage}>&lt;</button>
            <img
              className="viewer-image"
              src={images[selectedImageIndex].image_url}
              alt={images[selectedImageIndex].image_alt || 'Image'}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/fallback-image.jpg";
              }}
            />
            <button className="next-btn" onClick={showNextImage}>&gt;</button>
          </div>
        )}
      </div>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default ImageGallery;
